import BoardAudit from './src/main';

/* istanbul ignore next */
BoardAudit.install = function(Vue) {
  Vue.component(BoardAudit.name, BoardAudit);
};

export default BoardAudit;
